import { useCaseByIdQuery } from '@/queries/case';
import { useCaseIdContext } from '@/contexts';

export const useBaseCaseDetails = () => {
  const { caseId } = useCaseIdContext();

  if (!caseId) {
    throw new Error('No caseId provided');
  }

  const { data: caseData } = useCaseByIdQuery(caseId);

  if (!caseData) {
    throw new Error('No case provided');
  }

  return caseData;
};
